import { createSelector } from './selectorWrapper'
import { IDetailPageState } from '../reducers'
import { ATF_DECORATION_SCHEME, BTF_DECORATION_SCHEME } from '../reducers/action'
import { DETAIL_FRAGMENT, HEADER_DETAIL_FRAGMENT } from '../reducers/detail'

export const simpleSelectors = {
  context: (state: IDetailPageState) => state.requestContext!,
  features: (state: IDetailPageState) => state.features,
  pageTitleId: (state: IDetailPageState) => state.pageTitleId,
  preferences: (state: IDetailPageState) => state.customerPreferences,
  bundleCarousel: (state: IDetailPageState) => state.bundleCarousel,
  collections: (state: IDetailPageState) => state.collections,
  carousel: (state: IDetailPageState) => state.carousel,
  pageLink: (state: IDetailPageState) => state.pageLink,
  actionAtf: (state: IDetailPageState) => state.action[ATF_DECORATION_SCHEME],
  actionBtf: (state: IDetailPageState) => state.action[BTF_DECORATION_SCHEME],
  seasons: (state: IDetailPageState) => state.seasons,
  buyboxTitleId: (state: IDetailPageState) => state.buyboxTitleId,
  crowBanner: (state: IDetailPageState) => state.banner.crow,
  creative: (state: IDetailPageState) => state.creative,
  headerDetail: (state: IDetailPageState) => state.detail[HEADER_DETAIL_FRAGMENT],
  detail: (state: IDetailPageState) => state.detail[DETAIL_FRAGMENT],
  self: (state: IDetailPageState) => state.self,
  imdb: (state: IDetailPageState) => state.imdb,
  notification: (state: IDetailPageState) => state.notification,
  refund: (state: IDetailPageState) => state.refund.fragments,
  refunding: (state: IDetailPageState) => state.refund.refunding,
  restriction: (state: IDetailPageState) => state.restriction,
  trailer: (state: IDetailPageState) => state.trailer,
  watchlist: (state: IDetailPageState) => state.watchlist,
  hoverWatchlist: (state: IDetailPageState) => state.hoverWatchlist,
  purchase: (state: IDetailPageState) => state.purchase,
  pageContext: (state: IDetailPageState) => state.pageContext,
  deeplinking: (state: IDetailPageState) => state.deeplinking,
  bottomBar: (state: IDetailPageState) => state.bottomBar,
  devices: (state: IDetailPageState) => state.devices,
  useBtfTab: (state: IDetailPageState) => state.features.useBtfTab,
  isStarlightEnhanced: (state: IDetailPageState) => state.features.isStarlightEnhanced,
  atfTreatment: (state: IDetailPageState) => state.features.atfTreatment
}

type SimpleSelectorType<T extends any> = (
  state: IDetailPageState
) => { [key: string]: T }
export const pageSelectorFactory = <T extends any>(
  simpleSelector: SimpleSelectorType<T>
) =>
  createSelector(
    [simpleSelectors.pageTitleId, simpleSelector],
    (pageTitleId: string, selector: { [key: string]: T }) =>
      selector[pageTitleId]
  )

export const pageSelectors = {
  actionAtf: pageSelectorFactory(simpleSelectors.actionAtf),
  collections: pageSelectorFactory(simpleSelectors.collections),
  seasons: pageSelectorFactory(simpleSelectors.seasons),
  bundleCarousel: pageSelectorFactory(simpleSelectors.bundleCarousel),
  buyboxTitleId: pageSelectorFactory(simpleSelectors.buyboxTitleId),
  creative: pageSelectorFactory(simpleSelectors.creative),
  headerDetail: pageSelectorFactory(simpleSelectors.headerDetail),
  detail: pageSelectorFactory(simpleSelectors.detail),
  self: pageSelectorFactory(simpleSelectors.self),
  imdb: pageSelectorFactory(simpleSelectors.imdb),
  notification: pageSelectorFactory(simpleSelectors.notification),
  refund: pageSelectorFactory(simpleSelectors.refund),
  restriction: pageSelectorFactory(simpleSelectors.restriction),
  trailer: pageSelectorFactory(simpleSelectors.trailer),
  watchlist: pageSelectorFactory(simpleSelectors.watchlist),
  crowBanner: pageSelectorFactory(simpleSelectors.crowBanner),
}
